<template>
    <b-card
        no-body
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4>{{ $t("org.billing.Distribution ID Cost") }}</h4>
            </div>
        </div>
        <div class="b-table-sticky-header table-responsive">
            <b-table-simple
                no-border-collapse
            >
                <b-thead>
                    <b-tr>
                        <b-th
                            style="width:100px;"
                        >
                            Distribution ID
                        </b-th>
                        <b-th
                            style="width:100px;"
                            class="text-right"
                        >
                            Cost
                        </b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="({ distributionId, resourceId, cost }, index) in data" :key="index">
                        <b-td :title="resourceId">
                            {{ distributionId }}
                        </b-td>
                        <b-td class="text-right text-nowrap">
                            {{ $_getDollar(cost) }}
                        </b-td>
                    </b-tr>
                    <b-tr v-if="noData">
                        <b-td colspan="2" class="pb-50 pt-2 text-center">
                            <SVGEmptyIcon/>
                            <div>

                                {{ $t("org.message.No Data") }}
                            </div>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </div>
    </b-card>
</template>

<script>
import { computed, toRefs } from '@vue/composition-api'
import SVGEmptyIcon from '@/assets/images/empty.svg'
export default {
    components: {
        SVGEmptyIcon
    },
    props: {
        data: {
            type: Array,
            default: function () {
                return []
            }
        },
        themeColors: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    setup (props, context) {
        const { data } = toRefs(props)
        const noData = computed(() => !data.value.length)
        return {
            noData
        }
    }
}
</script>

<style>

</style>
